<template>
<div class="did-container">
    <div class="content">
      <nav class="nav-header">
        <p @click="$router.push({name: 'company-admin-dids-local-did'})"
          :class="($route.name === 'company-admin-dids-local-did') ? 'active' : ''" class="first">Local</p>
        <p @click="$router.push({name: 'company-admin-dids-toll-free'})"
          :class="($route.name === 'company-admin-dids-toll-free') ? 'active' : ''">Toll Free</p>
      </nav>
       <router-view class="router-container" />
    </div>
</div>   
</template>

<script>

import { format } from 'date-fns'

export default {
  components: {
    SearchInput: () => import('@/components/Inputs/SearchInput.vue'),
    SecondaryButton: () => import('@/components/Buttons/SecondaryButton.vue'),
    PrimaryButton: () => import('@/components/Buttons/PrimaryButton.vue'),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
  },
  data: () => ({
      types: ['Landline', 'Virtual', 'Toll Free', 'Mobile'],
      showDropDown: false,
      dids: [],
      Page: 0,
      SearchDid: '',
      TotalPages: null,
      company_logo_path: null,
      type: null,
      active: null,
      selectedDids: [],
  }),
  watch: {
    SearchDid: function() {
      this.Page = 0;
      this.GetList();
    }, 
    type: function() {
      this.Page = 0;
      this.GetList();
    }
  },
  created() {
    this.GetList();
    this.$store.dispatch('GetCompany', this.$store.getters.getUser.company_uuid).then( (res) => {
        this.company_logo_path =  res.contact.logo_file_uuid;
    });   
  },
  methods: {
    isActive(did) {
        this.selectedDids.push(did.number);
        this.active = !this.active;
        this.dids.map((item) => {
            if(item == did) {
                did.active = !did.active;
            }
        })
    },
    changePage(page) {
        this.Page = page;
        this.GetList();
    },
    GetList() {
        this.$store.dispatch('GetAllDids', {
            page: this.Page,
            did: this.SearchDid.trim(),
            type: this.type
        }).then(res => {
        this.dids = res.items.map(this.transformDids);
        this.TotalPages = res.total / res.per_page;
        });
    },
    deleteDid(did) {
        this.$swal({
            title: "Are you sure?",
            text: "You will not be able to recover this did!",
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, keep it"
        }).then(result => {
            if (result.value) {
                this.$store.dispatch('AssignDid', {
                    did: did,
                    companyId: {company_uuid: null }
                })
                .then(() => {
                    this.$swal("Deleted!", "Did has been deleted.", "success");
                    this.GetList();
                })
                .catch(err => {
                    this.$error(err);
                });
            }
        });
    },
    transformDids (i, k) {
      return {
        number:  i.did,
        createdBy: i.created_by,
        countryName: i.iso3, // this.GetCountryName(i.country_uuid),
        createdOn: format(i.created_on, 'D MMM YYYY'),
        state: i.state,
        lata: i.lata ? i.lata : '',
        type: i.type,
        didType: i.did_type,
        active: false,
      }
    }, 
    GetCountryName(id) {
        this.$store.dispatch('UserGetCountry', id).then( (res) => {
            return res.nice_name 
        });
    },
  }
}
</script>

<style lang="scss" scoped>
.did-container {
    padding: 0;
    margin-top: 20px;
    .content {
        height: fit-content;
        .nav-header {
            height: 50px;
            background-color: #fff;
            padding: 0px 15px 0px 15px;
            display: flex;
            p {
                cursor: pointer;
                height: 100%;
                display: flex;
                align-items: center;
                padding: 0px 5px 0px 5px;
                color: #bdbfd8;
                font-family: ""Helvetica Neue"";
                font-size: 16px;
                font-weight: 500;
                line-height: 20px;
                text-align: center;
                margin-right: 10px;
                margin-bottom: 0;
            }
            .active {
                color: #51a3f3;
                border-bottom: 2px solid #51a3f3;
            }
        }
    }

    .buttons-wrapper {
        display: flex;
        align-items: center;
        width: fit-content;
        margin-top: 20px;
        .secondary-but.ton {
            height: 40px;	
            width: 90px;
            margin-right: 15px;
        }
    }
}
.search-container {
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    .right-wrapprr {
        display: flex;
        align-items: center;
        width: fit-content;
        .search-input {
            height: 36px;
            width: 247px;
            background-color: #FFFFFF;
            margin-bottom: 0;
        }
        .selects-wrapper {
            display: flex;
            align-items: center;
            width: fit-content;
            .filter_by {	
                height: 40px;	
                width: 85px;	
                color: #55616E;	
                font-weight: normal;
                font-family: "Helvetica Neue";	
                font-size: 14px;	
                line-height: 25px;
                padding: 10px 0 10px 30px;
            }
            .type {
                height: 40px;	
                width: 100px;
                margin-bottom: 10px;
                color: #55616E;
                font-weight: normal;
            }
        }
    }
    .secondary-button {
        border-radius: 4px;	
        background-color: #51A3F3;
        color: #FFFFFF;
    }
    .buttons-wrapper {
        display: flex;
        align-items: center;
        width: fit-content;
        margin-top: 0;
        .secondary-button {
            border-radius: 4px;	
            background-color: #51A3F3;
            color: #FFFFFF;
        }
        .secondary-button.importDid {
            height: 40px;	
            width: 120px;
            margin-right: 15px;
            margin-left: 15px;
        }
        .secondary-button.buyDid {
            height: 40px;	
            width: 100px;
            margin-right: 15px;
        }
        .secondary-button.deleteAll {
            height: 40px;	
            width: 120px;
            margin-right: 15px;
        }
        .secondary-button.deleteSelected {
            height: 40px;	
            width: 160px;
            margin: 0;
        }
    }
}
table.Invoice_table {
    width: 100%;
} 
table thead tr {
    background: #F8F9FE;
}
table thead th:first-child {
    padding-left: 20px;
    padding-right: 100px;
}
tbody th:first-child {
    padding-left: 20px;
    padding-right: 50px;
}
table, tr {
    width: 100%;
    box-shadow: inset 0 -1px 0 0 #F0F1FA;
    -webkit-box-shadow: inset 0 -1px 0 0 #F0F1FA;
    -moz-box-shadow: inset 0 -1px 0 0 #F0F1FA;
    background-color: #FFFFFF;
}
table tr th {
    padding: 12px 0;
}
table {
    border-collapse: collapse;
}
.Invoice_table_popup {
    width: 75px;
}
.Invoice_table_header th {
    color: #212B36;	
    font-family: 'Helvetica Neue';
    font-size: 14px;	
    font-weight: 600;	
    line-height: 16px;
    padding: 11px 20px 10px 0;
}
.popup_content {
    display: none;
}
.popup_cta {
    cursor: pointer;
    padding-right: 5px;
}
.Invoice_table_popup {
    text-align: right;
    position: relative;
}
tbody th {
    height: 20px;		
    color: #212B36;
    font-family: "Helvetica Neue";
    font-weight: normal;	
    font-size: 14px;	
    line-height: 20px;
    padding: 15px 10px;
    min-width: 70px;
}
.Invoice_price {
    font-family: 'Helvetica Neue';
}
.Invoice_table_popup.active .popup_content {
    display: block;
    position: absolute;
    right: 0;
    width: 240px;
    border-radius: 4px;
    background-color: #FFFFFF;
    box-shadow: 0 10px 40px 0 rgba(0,0,0,0.1);
    padding-left: 0;
    list-style-type: none;
    text-align: left;
}
.Invoice_table_popup.active .popup_content a {
    color: #55616E;
    font-size: 16px;
    line-height: 20px;
    text-decoration: none;
    font-family: "Helvetica Neue";
    padding: 10px 15px;
    display: inline-block; 
}
.popup_image {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    vertical-align: middle;
    margin-right: 8px; 
}
th.user_active:after {
    content: "";
    height: 10px;
    width: 10px;
    background-color: #24E2B8;
    position: absolute;
    border-radius: 50%;
    left: 12px;
    top: 17px;
}
th.img_contaioner {
    padding: 7px 0;
}
th.user_active {
    text-align: left;
    position: relative;
    padding-left: 32px;
}
th.icon {
    float: right;
    padding: 7px 0;
    height: 44px;
    .svg-grey {
        height: 30px;
        width: 30px;
        cursor: pointer;
        fill: #55616E;
    }
    .delete {
        margin-left: 20px;
        margin-right: 20px;
    }
}
th .callflow {
    font-size: 12px;
    width: 110px;
    height: 20px;
    padding-top: 0px;
    float: right;
    line-height: 20px;
}
th .number-icon {
    height: 16px;
    width: 16px;
    margin-right: 8px;
}
</style>

